import { LocaleEnum } from "lopermut"
import z from "zod"

export const OrganizationResponseData = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  slug: z.string(),
  code: z.string().nullish(),
  phone: z.string().nullish(),
  logo: z.string().nullish(),
  locale: LocaleEnum,
  phoneNumbers: z.string().nullish(),
})
